import React from 'react';
import { InnerLayout } from '@layout';
export default function SingleColumn(props) {
  return <InnerLayout
    maxWidth={1100}
    {...props}
  />;
}
